import { render } from "./Projects.vue?vue&type=template&id=9c3ca2d2"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"
script.render = render

export default script